import React from 'react'
import store from '../../store/Store'
import routes from '../../routes/Routes'

import actionTypes from '../../actionTypes/actionTypes'
import actions from '../../actions/Actions'

import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'

import { Redirect } from 'react-router-dom'

import Navigation from '../navigation/Navigation'
import PageSelection from '../pageSelection/PageSelection'

import InputAdornment from '@material-ui/core/InputAdornment'
import FormHelperText from '@material-ui/core/FormHelperText'
import FormControl from '@material-ui/core/FormControl'
import Input from '@material-ui/core/Input'

import Card from '@material-ui/core/Card'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'

import Modal from '@material-ui/core/Modal'

import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined'
import LockOpenIcon from '@material-ui/icons/LockOpen'
import Icon from '@material-ui/core/Icon'
import IconButton from '@material-ui/core/IconButton'
import MergeTypeIcon from '@material-ui/icons/MergeType'
import VerticalSplitOutlinedIcon from '@material-ui/icons/VerticalSplitOutlined'
import HorizontalSplitOutlinedIcon from '@material-ui/icons/HorizontalSplitOutlined'
import HeightIcon from '@material-ui/icons/Height'
import CloseIcon from '@material-ui/icons/Close'
import MenuOpenIcon from '@material-ui/icons/MenuOpen'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import ImageIcon from '@material-ui/icons/Image'
import VideoLabelIcon from '@material-ui/icons/VideoLabel'
import TextFieldsIcon from '@material-ui/icons/TextFields'
import NavigationOutlinedIcon from '@material-ui/icons/NavigationOutlined'
import SelectAllIcon from '@material-ui/icons/SelectAll'
import EditIcon from '@material-ui/icons/Edit'
import BorderRightIcon from '@material-ui/icons/BorderRight'
import BorderLeftIcon from '@material-ui/icons/BorderLeft'
import BorderBottomIcon from '@material-ui/icons/BorderBottom'
import BorderTopIcon from '@material-ui/icons/BorderTop'
import BorderOuterIcon from '@material-ui/icons/BorderOuter'
import BorderAllIcon from '@material-ui/icons/BorderAll'
import DashboardIcon from '@material-ui/icons/Dashboard'
import OpenWithIcon from '@material-ui/icons/OpenWith'
import TableChartIcon from '@material-ui/icons/TableChart'
import DescriptionIcon from '@material-ui/icons/Description'
import QueueIcon from '@material-ui/icons/Queue'
import VerticalAlignCenterIcon from '@material-ui/icons/VerticalAlignCenter'
import VerticalAlignBottomIcon from '@material-ui/icons/VerticalAlignBottom'
import VerticalAlignTopIcon from '@material-ui/icons/VerticalAlignTop'
import SaveIcon from '@material-ui/icons/Save'
import SlideshowIcon from '@material-ui/icons/Slideshow'
import CancelPresentationIcon from '@material-ui/icons/CancelPresentation'
import SettingsBackupRestoreIcon from '@material-ui/icons/SettingsBackupRestore'
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward'
import ViewAgendaOutlinedIcon from '@material-ui/icons/ViewAgendaOutlined'
import ViewArrayIcon from '@material-ui/icons/ViewArray'
import ViewDayIcon from '@material-ui/icons/ViewDay'
import DeleteForeverOutlined from '@material-ui/icons/DeleteForeverOutlined'
import ViewStreamIcon from '@material-ui/icons/ViewStream'
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'

import './editorContextMenu.scss'

type editorContextMenuState = {
	article: any;
	navigation: any;
	history: any;
}

type editorContextMenuProps = {
	article: any;
	navigation: any;
	history: any;
}

class EditorContextMenu extends React.Component<editorContextMenuProps, editorContextMenuState> {

  constructor(props) {
  	super(props)

  	// console.log(this.props)

  	this.state = {
  		history: props.history,
  		article: props.article,
      	navigation: props.navigation
  	}
  }

  componentDidMount() {
  	store.subscribe(() => {
  		this.setState({
  			article: store.getState().article,
        	navigation: store.getState().navigation
  		})
  	})

    document.addEventListener("click", this.handleClick.bind(this))
    document.addEventListener("contextmenu", this.handleContextMenu.bind(this))
    document.addEventListener('keyup', this.handleKeyEvent.bind(this))
  }

  componentWillUnmount() {
    store.subscribe(() => {
      this.setState({
        article: store.getState().article,
        navigation: store.getState().navigation
      })
    })

    document.removeEventListener('click', this.handleClick.bind(this));
    document.removeEventListener('contextmenu', this.handleContextMenu.bind(this));
    document.removeEventListener('keyup', this.handleKeyEvent.bind(this));
  }

  handleClick = (event) => {
    // console.log('CLICKED')
    // console.log(event)

    const { navigation } = this.state

    /*if (table.contextMenu.menu) {
      actions.navigationActions.changeContextMenu({
        menu: !table.contextMenu.menu,
        posX: event.pageX,
        posY: event.pageY
      })
    }*/
  }

  closeContextMenu = () => {
    // console.log('CLOSE CONTEXT MENU')

    const { article } = this.state

    if (article.contextMenu.open) {
      actions.articleActions.changeContextMenu({
        open: !article.contextMenu.open,
        subMenuOpen: !article.contextMenu.subMenuOpen ? article.contextMenu.subMenuOpen : !article.contextMenu.subMenuOpen,
        posX: 0,
        posY: 0
      })
    }
  }

  handleKeyEvent = (event) => {
    const { 
      article,
      navigation
    } = this.state

    let activeKeyEvents = true

    article.pages[article.info.currentPage].edit.length > 0 ? activeKeyEvents = false : null

    if (activeKeyEvents) {
      switch (event.keyCode) {
        case 27:
          // console.log('Pressed Escape')

          this.closeContextMenu()
          break
        case 65:
          // console.log('Pressed A')

          actions.articleActions.changeContextMenu({
            open: true,
            subMenuOpen: true,
            fixed: true,
            orientation: 0,
            resize: false,
            align: true,
            edit: false,
            article: false,
            border: false,
            split: false,
            media: false
          })

          break
        case 66:
          // console.log('Pressed B')

          actions.articleActions.changeContextMenu({
            open: true,
            subMenuOpen: true,
            fixed: true,
            orientation: 0,
            resize: false,
            align: false,
            edit: false,
            article: false,
            border: true,
            split: false,
            media: false
          })

          break
        case 77:
          // console.log('Pressed M')

          actions.articleActions.changeContextMenu({
            open: true,
            subMenuOpen: true,
            fixed: true,
            orientation: 0,
            resize: false,
            align: false,
            edit: false,
            article: false,
            border: false,
            split: false,
            media: true
          })

          break
        case 82:
          // console.log('Pressed R')

          actions.articleActions.changeContextMenu({
            open: true,
            subMenuOpen: true,
            fixed: true,
            orientation: 0,
            resize: true,
            align: false,
            edit: false,
            article: false,
            border: false,
            split: false,
            media: false
          })

          if (!navigation.resize.active) {
            this.resize(1, true)
          } else if (navigation.resize.value === 0) {
            this.resize(0, true)
          } else if (navigation.resize.value === 1) {
            this.resize(1, true)
          }
          break
        case 83:
          // console.log('Pressed S')

          actions.articleActions.changeContextMenu({
            open: true,
            subMenuOpen: true,
            fixed: true,
            orientation: 0,
            resize: false,
            align: false,
            edit: false,
            article: false,
            border: false,
            split: true,
            media: false
          })

          break
        default:
          break
      }
    }
  }

  handleContextMenu = (event) => {
    // console.log('CONTEXT MENU')
    // console.log(event)

    const { article } = this.state

    event.preventDefault()

    if (article.contextMenu.open) {
      actions.articleActions.changeContextMenu({
        open: article.contextMenu.open,
        posX: event.pageX,
        posY: event.pageY
      })
    } else {
      actions.articleActions.changeContextMenu({
        open: !article.contextMenu.open,
        posX: event.pageX,
        posY: event.pageY
      })
    }
  }

  details = () => {
    const { article } = this.state

    actions.articleActions.changeDetails({ details: !article.details })
  }

  splitVertical = () => {

  }

  splitHorizontal = () => {
  	
  }

  verticalSplit = () => {
    // console.log('Vertical Split: ' + store.getState().template.templateIndex)

    const { article } = this.state

    actions.articleActions.increaseColumns({
      index: article.info.currentPage
    })
  }

  horizontalSplit = () => {
    // console.log('Horizontal Split: ' + store.getState().template.templateIndex)

    const { article } = this.state

    actions.articleActions.increaseRows({
      index: article.info.currentPage
    })
  }

  verticalRemove = () => {
    // console.log('Vertical Split: ' + store.getState().template.templateIndex)

    const { article } = this.state

    /* actions.articleActions.decreaseColumns({
      index: article.info.currentPage,
      column: 1
    }) */
  }

  horizontalRemove = () => {
    // console.log('Horizontal Split: ' + store.getState().template.templateIndex)

    const { article } = this.state

    /* actions.articleActions.decreaseRows({
      index: article.info.currentPage,
      row: 1
    }) */
  }

  onChangeDetailsOrientation = () => {
    const { article } = this.state

    actions.articleActions.changeDetailsOrientation({ detailsOrientation: article.detailsOrientation === 0 ? 1 : 0 })
  }

  onCloseDetails = () => {
    const { article } = this.state

    actions.articleActions.changeDetails({ details: !article.details })
  }

  onMouseOver = (id, clickEvent) => {
  	
  }

  onClicked = (id, clickEvent) => {
  	
  }

  onChangeWidth = (item, event) => {
    console.log('onChangeWidth')
  }

  onChangeHeight = (item, event) => {
    console.log('onChangeHeight')
  }

  renderSelectedDetails = () => {
    const { article } = this.state

    let details = []
    let image = false
    let video = false
    let text = false

    for (let i = 0; i < article.image.length; i++) {
      if (article.selected[0].row === article.image[i].row && article.selected[0].column === article.image[i].column) {
        image = true
      }
    }

    for (let i = 0; i < article.video.length; i++) {
      if (article.selected[0].row === article.video[i].row && article.selected[0].column === article.video[i].column) {
        video = true
      }
    }

    for (let i = 0; i < article.text.length; i++) {
      if (article.selected[0].row === article.text[i].row && article.selected[0].column === article.text[i].column) {
        text = true
      }
    }

    details.push(
      <div>
        Row: { article.selected[0].row }<br />
        Column: { article.selected[0].column }<br />
        Widht:&nbsp;

        {
          article.width.length > 0 ? (
            article.width.map((item, index, array) => {
              if (item.column === article.selected[0].column) {
                return (
                  <input 
                    value={ item.width }
                    autoFocus
                    placeholder={ "e.g. 100px or 30%" }
                    onChange={ this.onChangeWidth.bind(this, item) }
                  />
                )
              }
            })
          ) : (
            <input
              placeholder={ "e.g. 100px or 30%" }
              onChange={ this.onChangeWidth.bind(this, article.selected[0]) }
            />
          )
        }

        <br />

        Height:&nbsp;

        {
          article.height.length > 0 ? (
            article.height.map((item, index, array) => {
              if (item.row === article.selected[0].row) {
                return (
                  <input 
                    value={ item.height }
                    autoFocus
                    placeholder={ "e.g. 100px or 30%" }
                    onChange={ this.onChangeHeight.bind(this, item) }
                  />
                )
              }
            })
          ) : (
            <input
              placeholder={ "e.g. 100px or 30%" }
              onChange={ this.onChangeHeight.bind(this, article.selected[0]) }
            />
          )
        }

        <br />

        Type:&nbsp;

        {
          text ? (
            <div
              style={{
                display: 'inline-block'
              }}
            >
              Text
            </div>
          ) : image ? (
            <div
              style={{
                display: 'inline-block'
              }}
            >
              Image
            </div>
          ) : video ? (
            <div
              style={{
                display: 'inline-block'
              }}
            >
              Video
            </div>
          ) : (
            null
          )
        }

      </div>
    )

    return details
  }

  renderArticleDetails = () => {
    const { article } = this.state

    let articleDetails = []

    articleDetails.push(
      <div>
        Created: { article.info.creationTimestamp }<br />
        Updated: { article.info.updatedTimestamp }<br />
        Name: { article.info.name }<br />
        ID: { article.info.id }<br />
        Pages: { article.info.pages }<br />
        Current Page: { article.info.currentPage }<br />
        Previous Page: { article.info.previousPage }<br />
        Released: { article.info.released }<br />
        German: { article.info.languages.german }<br />
        English: { article.info.languages.english }
      </div>
    )

    return articleDetails
  }

  renderPageDetails = () => {
    const { article } = this.state

    let pageDetails = []

    pageDetails.push(
      <div>
        Rows: { article.rows }<br />
        Columns: { article.columns }
      </div>
    )

    return pageDetails
  }

  renderHoveredDetails = () => {
    const { article } = this.state

    let details = []
    let image = false
    let video = false
    let text = false

    for (let i = 0; i < article.image.length; i++) {
      if (article.hovered[0].row === article.image[i].row && article.hovered[0].column === article.image[i].column) {
        image = true
      }
    }

    for (let i = 0; i < article.video.length; i++) {
      if (article.hovered[0].row === article.video[i].row && article.hovered[0].column === article.video[i].column) {
        video = true
      }
    }

    for (let i = 0; i < article.text.length; i++) {
      if (article.hovered[0].row === article.text[i].row && article.hovered[0].column === article.text[i].column) {
        text = true
      }
    }

    details.push(
      <div>
        Row: { article.hovered[0].row }<br />
        Column: { article.hovered[0].column }<br />
        Widht:&nbsp;

        {
          article.width.map((item, index, array) => {
            console.log('Array: ' + array)
            console.log(array)
            console.log('Item: ' + item)
            console.log(item)
            console.log('Index: ' + index)
            console.log(index)

            if (item.column === article.hovered[0].column) {
              return item.width
            }
          })
        }

        <br />

        Height:&nbsp;

        {
          article.height.map((item, index, array) => {
            if (item.row === article.hovered[0].row) {
              return item.height
            }
          })
        }

        <br />

        Type:&nbsp;

        {
          text ? (
            <div
              style={{
                display: 'inline-block'
              }}
            >
              Text
            </div>
          ) : image ? (
            <div
              style={{
                display: 'inline-block'
              }}
            >
              Image
            </div>
          ) : video ? (
            <div
              style={{
                display: 'inline-block'
              }}
            >
              Video
            </div>
          ) : (
            null
          )
        }

      </div>
    )

    return details
  }

  checkMergeable = () => {
    console.log('Check Mergeable')

    return true
  }

  onMerge = () => {
    const {
      article
    } = this.state

    article.selected.sort((a, b) => a.row <= b.row && a.column <= b.column ? -1 : 1)

    let valid = false
    let singleRow = false
    let singleColumn = false

    let startRow = -1
    let startColumn = -1
    let endRow = -1
    let endColumn = -1

    let colSpanCount = -1
    let rowSpanCount = -1

    let skipStartRow = -1
    let skipRow = -1

    if (article.selected.length > 1) {
      for (let i = 0; i < article.selected.length; i++) {
        // console.log('[' + article.selected[i].row + ', ' + article.selected[i].column + ']')

        if (i === 0) {
          // console.log('First Selected')

          startRow = article.selected[i].row
          startColumn = article.selected[i].column
        } else if (i === article.selected.length - 1) {
          // console.log('Last Selected')

          endRow = article.selected[i].row
          endColumn = article.selected[i].column
        } else {
          // console.log('Middle Selected')
        }
      }
    }    

    let row = startRow
    let column = startColumn

    console.log('End Row: ' + endRow)
    console.log('End Column: ' + endColumn)

    console.log('Start Row: ' + startRow)
    console.log('Start Column: ' + startColumn)
    console.log('End Row: ' + endRow)
    console.log('End Column: ' + endColumn)

    colSpanCount = endColumn - startColumn + 1
    rowSpanCount = endRow - startRow + 1

    console.log('Column Span: ' + (endColumn - startColumn + 1))
    console.log('Row Span: ' + (endRow - startRow + 1))

    console.log('Skip Start Row: ' + (endColumn - startColumn))
    console.log('Skip Row: ' + (endColumn - startColumn + 1))

    skipStartRow = endColumn - startColumn
    skipRow = endColumn - startColumn + 1

    if (startRow === endRow) {
      singleRow = true
    }

    if (startColumn === endColumn) {
      singleColumn = true
    }

    actions.articleActions.addSpan({
      row,
      column,
      colSpanCount,
      rowSpanCount
    })

    for (let i = 0; i < rowSpanCount; i++) {
      if (i === 0) {
        actions.articleActions.addSkip({
          row,
          skip: skipStartRow
        })
      } else {
        actions.articleActions.addSkip({
          row: row + i,
          skip: skipRow
        })
      }
    }

    this.unselectAll()
  }

  closeModal = () => {
    const { article } = this.state

    actions.articleActions.changeModal({
      modal: !article.modal
    })
  }

  resize = (value, key) => {
    const { navigation } = this.state

    let opposite = value === 0 ? 1 : 0

    console.log('RESIZE METHOD')

    navigation.resize.active && !key && navigation.resize.value === value ? (
      actions.navigationActions.resize({
        active: false,
        value: -1
      })
    ) : navigation.resize.active && !key && navigation.resize.value === 0 ? (
      actions.navigationActions.resize({
        active: true,
        value: 2
      })
    ) : navigation.resize.active && !key && navigation.resize.value === 1 ? (
      actions.navigationActions.resize({
        active: true,
        value: 2
      })
    ) : navigation.resize.active && !key && navigation.resize.value === 2 ? (
      actions.navigationActions.resize({
        active: true,
        value: opposite
      })
    ) : navigation.resize.active && key && navigation.resize.value === 0 ? (
      actions.navigationActions.resize({
        active: true,
        value: opposite
      })
    ) : navigation.resize.active && key && navigation.resize.value === 1 ? (
      actions.navigationActions.resize({
        active: true,
        value: opposite
      })
    ) : (
      actions.navigationActions.resize({
        active: true,
        value
      })
    )
  }

  renderContextMenu = () => {
    const { 
      article,
      navigation
    } = this.state

    let contextMenu = []
    let articleLength = 0

    article.pages.map((page, index, array) => {
      article.info.currentPage === page.index && page.selected.map((item, index, array) => {
        articleLength += 1
      })
    })

    contextMenu.push(
      <div
        style={{
			display: 'block',
			overflow: 'hidden'
        }}
      >

        <div
          style={{
            display: 'inline-block'
          }}
        >

          {
            this.renderResize()
          }

          {
            articleLength === 1 ? this.renderEdit() : null
          }

        </div>

        {
          articleLength > 1 ? (
            <div
              style={{
                display: 'inline-block'
              }}
            >
              <IconButton
                edge={ 'end' }
                className={ 'MenuButton' }
                color="inherit" 
                aria-label="menu"
                onClick={() => {
                  actions.articleActions.changeContextMenu({
                    subMenuOpen: !article.contextMenu.subMenuOpen ? true : article.contextMenu.subMenuOpen && article.contextMenu.border ? true : false,
                    border: !article.contextMenu.border,
                    split: false,
                    media: false,
                    resize: false,
                    edit: false,
                    article: false,
                    align: false
                  })
                }}
              >
                <Icon>
                  <BorderAllIcon />
                </Icon>
              </IconButton>

              <IconButton
                edge={ 'end' }
                className={ 'MenuButton' }
                color="inherit" 
                aria-label="menu"
                onClick={() => {
                  this.merge()
                }}
              >
                <Icon>
                  <MergeTypeIcon />
                </Icon>
              </IconButton>

              {
                this.renderUnselect()
              }

            </div>
          ) : articleLength > 0 ? (
            <div
              style={{
                display: 'inline-block'
              }}
            >

              {
                this.renderMedia() 
              }

              <IconButton
                edge={ 'end' }
                className={ 'MenuButton' }
                color="inherit" 
                aria-label="menu"
                onClick={() => {
                  actions.articleActions.changeContextMenu({
                    subMenuOpen: !article.contextMenu.subMenuOpen ? true : article.contextMenu.subMenuOpen && !article.contextMenu.border ? true : false,
                    border: !article.contextMenu.border,
                    split: false,
                    media: false,
                    resize: false,
                    edit: false,
                    article: false,
                    align: false
                  })
                }}
              >
                <Icon
                  style={{
                    color: article.contextMenu.border ? 'rgba(155, 155, 155, 255)' : 'rgba(231, 231, 231, 255)'
                  }}
                >
                  <BorderAllIcon />
                </Icon>
              </IconButton>

              {
                this.renderUnselect()
              }
              
            </div>
          ) : (
            <div
              style={{
                display: 'inline-block'
              }}
            >
              
              {
                (article.contextMenu.posY <= 50 || article.contextMenu.posX <= 50 || article.contextMenu.fixed) && this.renderSplit()
              }

              {
                !navigation.details && this.renderDetails()
              }

            </div>
          )
        }

        <div
          style={{
            display: 'inline-block'
          }}
        >

          {
            (article.contextMenu.posY <= 50 || article.contextMenu.posX <= 50 || article.contextMenu.fixed) && this.renderArticle()
          }

          {
            this.renderAlignContextMenu()
          }

          {
            this.renderCloseContextMenu()
          }
        
        </div>

      </div>
    )

    return contextMenu
  }

  onPageDown = () => {
    const { article } = this.state

    actions.articleActions.changePreviousPage(article.info.currentPage)

    if (article.info.currentPage < article.pages.length - 1) {
      actions.articleActions.changeCurrentPage(article.info.currentPage + 1)
    } else {
      actions.articleActions.changeCurrentPage(0)
    }
  }

  onPageUp = () => {
    const { article } = this.state

    actions.articleActions.changePreviousPage(article.info.currentPage)

    if (article.info.currentPage > 0) {
      actions.articleActions.changeCurrentPage(article.info.currentPage - 1)
    } else {
      actions.articleActions.changeCurrentPage(article.pages.length - 1)
    }
  }

  onPageDelete = () => {
    const { article } = this.state

    if (article.info.pages > 1) {
      actions.articleActions.removePage({ index: article.info.currentPage })
    }

    if (article.info.currentPage < article.pages.length - 1) {
      actions.articleActions.changeCurrentPage(article.info.currentPage + 1)
    } else {
      actions.articleActions.changeCurrentPage(0)
    }
  }

  renderContextSubMenu = () => {
    const { 
      article, 
      navigation 
    } = this.state

    let contextSubMenu = []

    contextSubMenu.push(
      <div
        style={{
          position: 'fixed',
          left: !article.contextMenu.fixed ? article.contextMenu.posX : 0,
          top: !article.contextMenu.fixed ? 'calc(article.contextMenu.posY + 50px)' : article.contextMenu.orientation === 0 ? '49px' : 'calc(100% - 99px)',
          minWidth: '48px',
          minHeight: '48px',
          border: '1px solid black',
          backgroundColor: 'rgba(255, 255, 255, 255)'
        }}
      >

        {
          article.contextMenu.resize ? (
            <div>
              <IconButton
                edge={ 'end' }
                className={ 'MenuButton' }
                color="inherit" 
                aria-label="menu"
                onClick={() => {
                  this.resize(0, false)
                }}
              >
                <Icon
                  style={{
                    color: navigation.resize.value === 0 || navigation.resize.value === 2 ? 'rgba(155, 155, 155, 255)' : 'rgba(231, 231, 231, 255)'
                  }}
                >
                  <HeightIcon />
                </Icon>
              </IconButton>

              <IconButton
                edge={ 'end' }
                className={ 'MenuButton' }
                color="inherit" 
                aria-label="menu"
                onClick={() => {
                  this.resize(1, false)
                }}
              >
                <Icon
                  style={{
                    transform: 'rotate(90deg)',
                    color: navigation.resize.value === 1 || navigation.resize.value === 2 ? 'rgba(155, 155, 155, 255)' : 'rgba(231, 231, 231, 255)'
                  }}
                >
                  <HeightIcon />
                </Icon>
              </IconButton>
            </div>
          ) : null
        }

        {
          article.contextMenu.border ? (
            <div>
              <IconButton
                edge={ 'end' }
                className={ 'MenuButton' }
                color="inherit" 
                aria-label="menu"
                onClick={() => {
                  this.border(true, -1)
                }}
              >
                <Icon>
                  <BorderOuterIcon />
                </Icon>
              </IconButton>

              <IconButton
                edge={ 'end' }
                className={ 'MenuButton' }
                color="inherit" 
                aria-label="menu"
                onClick={() => {
                  this.border(false, 0)
                }}
              >
                <Icon>
                  <BorderTopIcon />
                </Icon>
              </IconButton>

              <IconButton
                edge={ 'end' }
                className={ 'MenuButton' }
                color="inherit" 
                aria-label="menu"
                onClick={() => {
                  this.border(false, 2)
                }}
              >
                <Icon>
                  <BorderBottomIcon />
                </Icon>
              </IconButton>
              
              <IconButton
                edge={ 'end' }
                className={ 'MenuButton' }
                color="inherit" 
                aria-label="menu"
                onClick={() => {
                  this.border(false, 3)
                }}
              >
                <Icon>
                  <BorderLeftIcon />
                </Icon>
              </IconButton>

              <IconButton
                edge={ 'end' }
                className={ 'MenuButton' }
                color="inherit" 
                aria-label="menu"
                onClick={() => {
                  this.border(false, 1)
                }}
              >
                <Icon>
                  <BorderRightIcon />
                </Icon>
              </IconButton>
            </div>
          ) : null
        }

        {
          article.contextMenu.media ? (
            <div>
              <IconButton
                edge={ 'end' }
                className={ 'MenuButton' }
                color="inherit" 
                aria-label="menu"
                onClick={() => {
                  this.text()
                }}
              >
                <Icon>
                  <TextFieldsIcon />
                </Icon>
              </IconButton>

              <IconButton
                edge={ 'end' }
                className={ 'MenuButton' }
                color="inherit" 
                aria-label="menu"
                onClick={() => {
                  this.image()
                }}
              >
                <Icon>
                  <ImageIcon />
                </Icon>
              </IconButton>

              <IconButton
                edge={ 'end' }
                className={ 'MenuButton' }
                color="inherit" 
                aria-label="menu"
                onClick={() => {
                  this.video()
                }}
              >
                <Icon>
                  <VideoLabelIcon />
                </Icon>
              </IconButton>
            </div>
          ) : null
        }

        {
          article.contextMenu.split ? (
            <div>
              <IconButton
                edge={ 'end' }
                className={ 'MenuButton' }
                color="inherit" 
                aria-label="menu"
                onClick={() => {
                  this.verticalSplit()
                }}
              >
                <Icon
                  style={{
                    color: navigation.navigation ? 'rgba(155, 155, 155, 255)' : 'rgba(231, 231, 231, 255)'
                  }}
                >
                  <ViewArrayIcon />
                </Icon>
              </IconButton>

              <IconButton
                edge={ 'end' }
                className={ 'MenuButton' }
                color="inherit" 
                aria-label="menu"
                onClick={() => {
                  this.horizontalSplit()
                }}
              >
                <Icon
                  style={{
                    color: navigation.navigation ? 'rgba(155, 155, 155, 255)' : 'rgba(231, 231, 231, 255)'
                  }}
                >
                  <ViewStreamIcon />
                </Icon>
              </IconButton>

              <IconButton
                edge={ 'end' }
                className={ 'MenuButton' }
                color="inherit" 
                aria-label="menu"
                onClick={() => {
                  this.verticalRemove()
                }}
              >
                <Icon
                  style={{
                    color: navigation.navigation ? 'rgba(155, 155, 155, 255)' : 'rgba(231, 231, 231, 255)'
                  }}
                >
                  <KeyboardArrowDownIcon />
                </Icon>
              </IconButton>

              <IconButton
                edge={ 'end' }
                className={ 'MenuButton' }
                color="inherit" 
                aria-label="menu"
                onClick={() => {
                  this.horizontalRemove()
                }}
              >
                <Icon
                  style={{
                    color: navigation.navigation ? 'rgba(155, 155, 155, 255)' : 'rgba(231, 231, 231, 255)'
                  }}
                >
                  <KeyboardArrowRightIcon />
                </Icon>
              </IconButton>

              <IconButton
                edge={ 'end' }
                className={ 'MenuButton' }
                color="inherit" 
                aria-label="menu"
                onClick={() => {
                  this.pageSelection()
                }}
              >
                <Icon
                  style={{
                    color: navigation.pageSelection ? 'rgba(155, 155, 155, 255)' : 'rgba(231, 231, 231, 255)'
                  }}
                >
                  <MoreVertIcon />
                </Icon>
              </IconButton>

              <IconButton
                edge={ 'end' }
                className={ 'MenuButton' }
                color="inherit" 
                aria-label="menu"
                onClick={() => {
                  this.navigation()
                }}
              >
                <Icon
                  style={{
                    color: navigation.navigation ? 'rgba(155, 155, 155, 255)' : 'rgba(231, 231, 231, 255)'
                  }}
                >
                  <NavigationOutlinedIcon />
                </Icon>
              </IconButton>

              <IconButton
                edge={ 'end' }
                className={ 'MenuButton' }
                color="inherit" 
                aria-label="menu"
                onClick={() => {
                  this.negativePageSelection()
                }}
              >
                <Icon>
                  <VerticalSplitOutlinedIcon />
                </Icon>
              </IconButton>

              <IconButton
                edge={ 'end' }
                className={ 'MenuButton' }
                color="inherit" 
                aria-label="menu"
                onClick={() => {
                  this.negativeNavigation()
                }}
              >
                <Icon>
                  <HorizontalSplitOutlinedIcon />
                </Icon>
              </IconButton>
            </div>
          ) : null
        }

        {
          article.contextMenu.edit ? (
            <div>
              <IconButton
                edge={ 'end' }
                className={ 'MenuButton' }
                color="inherit" 
                aria-label="menu"
                onClick={() => {
                  this.onAddPage()
                }}
              >
                <Icon>
                  <NavigationOutlinedIcon />
                </Icon>
              </IconButton>
            </div>
          ) : null
        }

        {
          article.contextMenu.article ? (
            <div>
              <IconButton
                edge={ 'end' }
                className={ 'MenuButton' }
                color="inherit" 
                aria-label="menu"
                onClick={() => {
                  this.onAddPage()
                }}
              >
                <Icon>
                  <QueueIcon />
                </Icon>
              </IconButton>

              <IconButton
                edge={ 'end' }
                className={ 'MenuButton' }
                color="inherit" 
                aria-label="menu"
                onClick={() => {
                  this.onPageDown()
                }}
              >
                <Icon
                  style={{
                    transform: 'rotate(180deg)'
                  }}
                >
                  <ArrowUpwardIcon />
                </Icon>
              </IconButton>

              <IconButton
                edge={ 'end' }
                className={ 'MenuButton' }
                color="inherit" 
                aria-label="menu"
                onClick={() => {
                  this.onPageUp()
                }}
              >
                <Icon>
                  <ArrowUpwardIcon />
                </Icon>
              </IconButton>

              <IconButton
                edge={ 'end' }
                className={ 'MenuButton' }
                color="inherit" 
                aria-label="menu"
                onClick={() => {
                  this.onPageDelete()
                }}
              >
                <Icon>
                  <DeleteForeverOutlined />
                </Icon>
              </IconButton>

              {
                article.preview ? (
                  <IconButton
                    edge={ 'end' }
                    className={ 'MenuButton' }
                    color="inherit" 
                    aria-label="menu"
                    onClick={() => {
                      this.preview(false)
                    }}
                  >
                    <Icon
                      style={{
                        color: navigation.preview ? 'rgba(155, 155, 155, 255)' : 'rgba(231, 231, 231, 255)'
                      }}
                    >
                      <CancelPresentationIcon />
                    </Icon>
                  </IconButton>
                ) : (
                  <IconButton
                    edge={ 'end' }
                    className={ 'MenuButton' }
                    color="inherit" 
                    aria-label="menu"
                    onClick={() => {
                      this.preview(true)
                    }}
                  >
                    <Icon
                      style={{
                        color: navigation.preview ? 'rgba(155, 155, 155, 255)' : 'rgba(231, 231, 231, 255)'
                      }}
                    >
                      <SlideshowIcon />
                    </Icon>
                  </IconButton>
                )
              }

              <IconButton
                edge={ 'end' }
                className={ 'MenuButton' }
                color="inherit" 
                aria-label="menu"
                onClick={() => {
                  this.newTemplate()
                }}
              >
                <Icon>
                  <SettingsBackupRestoreIcon />
                </Icon>
              </IconButton>

              <IconButton
                edge={ 'end' }
                className={ 'MenuButton' }
                color="inherit" 
                aria-label="menu"
                onClick={() => {
                  this.saveTemplate()
                }}
              >
                <Icon>
                  <SaveIcon />
                </Icon>
              </IconButton>

              <IconButton
                edge={ 'end' }
                className={ 'MenuButton' }
                color="inherit" 
                aria-label="menu"
                onClick={ this.returnToOverview.bind(this) }
              >
                <Icon>
                  <ViewAgendaOutlinedIcon />
                </Icon>
              </IconButton>
            </div>
          ) : null
        }

        {
          article.contextMenu.align ? (
            <div>
              <IconButton
                edge={ 'end' }
                className={ 'MenuButton' }
                color="inherit" 
                aria-label="menu"
                onClick={() => {
                  this.onAlign(0)
                }}
              >
                <Icon
                  style={{
                    color: article.contextMenu.orientation === 0 ? 'rgba(155, 155, 155, 255)' : 'rgba(231, 231, 231, 255)'
                  }}
                >
                  <VerticalAlignTopIcon />
                </Icon>
              </IconButton>

              <IconButton
                edge={ 'end' }
                className={ 'MenuButton' }
                color="inherit" 
                aria-label="menu"
                onClick={() => {
                  this.onAlign(1)
                }}
              >
                <Icon
                  style={{
                    color: article.contextMenu.orientation === 1 ? 'rgba(155, 155, 155, 255)' : 'rgba(231, 231, 231, 255)'
                  }}
                >
                  <VerticalAlignBottomIcon />
                </Icon>
              </IconButton>
            </div>
          ) : null
        }

      </div>
    )

    return contextSubMenu
  }

  returnToOverview = () => {
  	const { history } = this.state

  	console.log(history)

  	actions.routeActions.changeRoute({
    	route: routes.ROUTE_OVERVIEW
  	})

  	history.push( routes.ROUTE_OVERVIEW )
  }

  preview = (preview) => {
    const { article } = this.state

    this.unselectAll()
    
    actions.articleActions.changePreview({
      preview
    })

    /* actions.articleActions.changeSpacing({
      index: article.info.currentPage,
      spacing: 0
    }) */

    actions.routeActions.changeRoute({
      route: routes.ROUTE_ROOT
    })
  }

  saveTemplate = () => {
    console.log('Save Template')

    const { article } = this.state

    actions.articleActions.changeModal({
      modal: !article.modal
    })
  }

  newTemplate = () => {
    console.log('New Template')

    actions.articleActions.newTemplate()
  }

  onAlign = (orientation) => {
    const { article } = this.state

    switch (orientation) {
      case 0:
        if (article.contextMenu.orientation === orientation) {
          actions.articleActions.changeContextMenu({
            subMenuOpen: false,
            fixed: false,
            orientation: -1,
            align: false
          })
        } else {
          actions.articleActions.changeContextMenu({
            fixed: true,
            orientation
          })
        }
        break
      case 1:
        if (article.contextMenu.orientation === orientation) {
          actions.articleActions.changeContextMenu({
            subMenuOpen: false,
            fixed: false,
            orientation: -1,
            align: false
          })
        } else {
          actions.articleActions.changeContextMenu({
            fixed: true,
            orientation
          })
        }
        break
      default:
        break
    }
  }

  renderCloseContextMenu = () => {
    let closeContextMenu = []

    closeContextMenu.push(
      <IconButton
        edge={ 'end' }
        className={ 'MenuButton' }
        color="inherit" 
        aria-label="menu"
        onClick={() => {
          this.closeContextMenu()
        }}
      >
        <Icon>
          <CloseIcon />
        </Icon>
      </IconButton>
    )

    return closeContextMenu
  }

  renderAlignContextMenu = () => {
    const { article } = this.state

    let alignContextMenu = []

    alignContextMenu.push(
      <IconButton
        edge={ 'end' }
        className={ 'MenuButton' }
        color="inherit" 
        aria-label="menu"
        onClick={() => {
          actions.articleActions.changeContextMenu({
            subMenuOpen: !article.contextMenu.subMenuOpen ? true : article.contextMenu.subMenuOpen && !article.contextMenu.align ? true : false,
            resize: false,
            media: false,
            split: false,
            border: false,
            edit: false,
            article: false,
            align: !article.contextMenu.align
          })
        }}
      >
        <Icon
          style={{
            color: (article.contextMenu.orientation === 0 || article.contextMenu.orientation === 1) ? 'rgba(155, 155, 155, 255)' : 'rgba(231, 231, 231, 255)'
          }}
        >
          <VerticalAlignCenterIcon />
        </Icon>
      </IconButton>
    )

    return alignContextMenu
  }

  readableDate = () => {
  	let today = new Date()
	let dd = String(today.getDate()).padStart(2, '0')
	let mm = String(today.getMonth() + 1).padStart(2, '0')
	let yyyy = today.getFullYear()

  	let readableDate = mm + '/' + dd + '/' + yyyy

  	console.log(today)
  	console.log(readableDate)

  	return readableDate
  }

  onAddPage = () => {
    const { article } = this.state

  	this.readableDate()

    actions.articleActions.addPage(article.info.currentPage)
  }

  renderEdit = () => {
    const { article } = this.state

    let edit = []

    article.pages.map((page, index, array) => {
      article.info.currentPage === page.index && page.selected.map((itemSelected, indexSelected, array) => {
        page.media.map((itemMedia, indexMedia, array) => {
          if (itemSelected.row === itemMedia.row && itemSelected.column === itemMedia.column && itemMedia.type !== -1) {
            edit.push(
              <div
                style={{
                  display: 'inline-block'
                }}
              >
                <IconButton
                  edge={ 'end' }
                  className={ 'MenuButton' }
                  color="inherit" 
                  aria-label="menu"
                  onClick={() => {
                    actions.articleActions.changeContextMenu({
                      subMenuOpen: !article.contextMenu.subMenuOpen ? true : article.contextMenu.subMenuOpen && !article.contextMenu.edit ? true : false,
                      resize: false,
                      media: false,
                      split: false,
                      border: false,
                      edit: !article.contextMenu.edit,
                      article: false,
                      align: false
                    })
                  }}
                >
                  <Icon>
                    <EditIcon />
                  </Icon>
                </IconButton>
              </div>
            )

            return edit
          }
        })
      })
    })
    
    return null
  }

  edit = () => {
    console.log('EDIT')
  }

  border = (all, direction) => {
    const { article } = this.state

    let included = false
    let borderIndex = -1

    if (article.selected.length > 0) {
      for (let selectedIndex = 0; selectedIndex < article.selected.length; selectedIndex++) {
        if (article.border.length < 1) {
          this.addBorder(article, selectedIndex, all, direction, borderIndex)
        } else if (article.border.length > 0) {
          for (let index = 0; index < article.border.length; index++) {
            if (article.selected[selectedIndex].row == article.border[index].row && article.selected[selectedIndex].column == article.border[index].column) {

              console.log('ALL: ' + all)
              console.log('DIRECTION: ' + direction)
              console.log('INDEX: ' + index)
              console.log('BORDERINDEX: ' + borderIndex)

              if (all && article.border[index].all) {
                included = true
              } else {
                borderIndex = index
                console.log('BORDERINDEX: ' + borderIndex)

                switch (direction) {
                  case 0:
                    article.border[index].top ? included = true : included = true
                    break
                  case 1:
                    article.border[index].right ? included = true : included = true
                    break
                  case 2:
                    article.border[index].bottom ? included = true : included = true
                    break
                  case 3:
                    article.border[index].left ? included = true : included = true
                    break
                  default:
                    break
                }
              }
            }
          }

          if (!included) {
            this.addBorder(article, selectedIndex, all, direction, borderIndex)
          } else {
            this.removeBorder(article, selectedIndex, all, direction, borderIndex)
          }
        }
      }
    }

    // this.unselectAll()
  }

  addBorder = (article, selectedIndex, all, direction, borderIndex) => {
    console.log('ADD BORDER: ' + all + ' ' + direction + ' ' + borderIndex)

    actions.articleActions.addBorder({
      row: article.selected[selectedIndex].row,
      column: article.selected[selectedIndex].column,
      all: all ? true : false,
      top: direction === 0 ? true : false,
      right: direction === 1 ? true : false,
      bottom: direction === 2 ? true : false,
      left: direction === 3 ? true : false
    })
  }

  removeBorder = (article, selectedIndex, all, direction, borderIndex) => {
    console.log('ADD BORDER: ' + all + ' ' + direction + ' ' + borderIndex)

    actions.articleActions.removeBorder({
      row: article.selected[selectedIndex].row,
      column: article.selected[selectedIndex].column,
      all: all ? true : false,
      top: direction === 0 ? true : false,
      right: direction === 1 ? true : false,
      bottom: direction === 2 ? true : false,
      left: direction === 3 ? true : false
    })
  }

  renderDetails = () => {
    const { navigation } = this.state

    let details = []

    details.push(
      <div
        style={{
          display: 'inline-block'
        }}
      >
        <IconButton
          edge={ 'end' }
          className={ 'MenuButton' }
          color="inherit" 
          aria-label="menu"
          onClick={() => {
            this.details()
          }}
        >
          <Icon
            style={{
              color: navigation.details ? 'rgba(155, 155, 155, 255)' : 'rgba(231, 231, 231, 255)'
            }}
          >
            <MenuOpenIcon />
          </Icon>
        </IconButton>
      </div>
    )

    return details
  }

  renderUnselect = () => {
    let unselect = []

    unselect.push(
      <div
        style={{
          display: 'inline-block'
        }}
      >
        <IconButton
          edge={ 'end' }
          className={ 'MenuButton' }
          color="inherit" 
          aria-label="menu"
          onClick={() => {
            this.unselectAll()
          }}
        >
          <Icon>
            <SelectAllIcon />
          </Icon>
        </IconButton>
      </div>
    )

    return unselect
  }

  renderPageSelection = () => {
    const { navigation } = this.state

    let pageSelection = []

    pageSelection.push(
      <div
        style={{
          display: 'inline-block'
        }}
      >
        <IconButton
          edge={ 'end' }
          className={ 'MenuButton' }
          color="inherit" 
          aria-label="menu"
          onClick={() => {
            this.pageSelection()
          }}
        >
          <Icon
            style={{
              color: navigation.pageSelection ? 'rgba(155, 155, 155, 255)' : 'rgba(231, 231, 231, 255)'
            }}
          >
            <MoreVertIcon />
          </Icon>
        </IconButton>
      </div>
    )

    return pageSelection
  }

  pageSelection = () => {
    // console.log('Render Navigation')

    let activePageSelection
    let pageIndex

    store.getState().article.pages.map((page, index, array) => {
      store.getState().article.info.currentPage === page.index ? activePageSelection = !page.activePageSelection : null
      store.getState().article.info.currentPage === page.index ? pageIndex = page.index : null
    })

    actions.articleActions.changeTablePageSelection({ 
      index: pageIndex,
      activePageSelection: activePageSelection
    })
  }

  negativePageSelection = () => {
    // console.log('Render Navigation')

    let activeNegativePageSelection
    let pageIndex

    store.getState().article.pages.map((page, index, array) => {
      store.getState().article.info.currentPage === page.index ? activeNegativePageSelection = !page.activeNegativePageSelection : null
      store.getState().article.info.currentPage === page.index ? pageIndex = page.index : null
    })

    actions.articleActions.changeTableNegativePageSelection({ 
      index: pageIndex,
      activeNegativePageSelection: activeNegativePageSelection
    })
  }

  renderNavigation = () => {
    const { navigation } = this.state

    let navi = []

    navi.push(
      <div
        style={{
          display: 'inline-block'
        }}
      >
        <IconButton
          edge={ 'end' }
          className={ 'MenuButton' }
          color="inherit" 
          aria-label="menu"
          onClick={() => {
            this.navigation()
          }}
        >
          <Icon
            style={{
              color: navigation.navigation ? 'rgba(155, 155, 155, 255)' : 'rgba(231, 231, 231, 255)'
            }}
          >
            <NavigationOutlinedIcon />
          </Icon>
        </IconButton>
      </div>
    )

    return navi
  }

  navigation = () => {
    // console.log('Render Navigation')

    let activeNavigation
    let pageIndex

    store.getState().article.pages.map((page, index, array) => {
      store.getState().article.info.currentPage === page.index ? activeNavigation = !page.activeNavigation : null
      store.getState().article.info.currentPage === page.index ? pageIndex = page.index : null
    })

    actions.articleActions.changeTableNavigation({ 
      index: pageIndex,
      activeNavigation: activeNavigation
    })
  }

  negativeNavigation = () => {
    // console.log('Render Negative Navigation')

    let activeNegativeNavigation
    let pageIndex

    store.getState().article.pages.map((page, index, array) => {
      store.getState().article.info.currentPage === page.index ? activeNegativeNavigation = !page.activeNegativeNavigation : null
      store.getState().article.info.currentPage === page.index ? pageIndex = page.index : null
    })

    actions.articleActions.changeTableNegativeNavigation({ 
      index: pageIndex,
      activeNegativeNavigation: activeNegativeNavigation
    })
  }

  renderSplit = () => {
    const { article } = this.state

    let split = []

    split.push(
      <div
        style={{
          display: 'inline-block'
        }}
      >
        <IconButton
          edge={ 'end' }
          className={ 'MenuButton' }
          color="inherit" 
          aria-label="menu"
          onClick={() => {
            actions.articleActions.changeContextMenu({
              subMenuOpen: !article.contextMenu.subMenuOpen ? true : article.contextMenu.subMenuOpen && !article.contextMenu.split ? true : false,
              resize: false,
              media: false,
              split: !article.contextMenu.split,
              border: false,
              edit: false,
              article: false,
              align: false
            })
          }}
        >
          <Icon>
            <TableChartIcon />
          </Icon>
        </IconButton>
      </div>
    )

    return split
  }

  renderResize = () => {
    const {
      navigation,
      article
    } = this.state

    let resize = []

    resize.push(
      <div
        style={{
          display: 'inline-block'
        }}
      >
        <IconButton
          edge={ 'end' }
          className={ 'MenuButton' }
          color="inherit" 
          aria-label="menu"
          onClick={() => {
            actions.articleActions.changeContextMenu({
              subMenuOpen: !article.contextMenu.subMenuOpen ? true : article.contextMenu.subMenuOpen && !article.contextMenu.resize ? true : false,
              resize: !article.contextMenu.resize,
              media: false,
              split: false,
              border: false,
              edit: false,
              article: false,
              align: false
            })
          }}
        >
          <Icon
            style={{
              color: navigation.resize.value === 0 || navigation.resize.value === 1 || navigation.resize.value === 2 ? 'rgba(155, 155, 155, 255)' : 'rgba(231, 231, 231, 255)'
            }}
          >
            <OpenWithIcon />
          </Icon>
        </IconButton>
      </div>
    )

    return resize
  }

  renderMedia = () => {
    const { article } = this.state

    let media = []

    media.push(
      <div
        style={{
          display: 'inline-block'
        }}
      >
        <IconButton
          edge={ 'end' }
          className={ 'MenuButton' }
          color="inherit" 
          aria-label="menu"
          onClick={() => {
            actions.articleActions.changeContextMenu({
              subMenuOpen: !article.contextMenu.subMenuOpen ? true : article.contextMenu.subMenuOpen && !article.contextMenu.media ? true : false,
              media: !article.contextMenu.media,
              resize: false,
              split: false,
              border: false,
              edit: false,
              article: false,
              align: false
            })
          }}
        >
          <Icon
            style={{
              color: article.contextMenu.media ? 'rgba(155, 155, 155, 255)' : 'rgba(231, 231, 231, 255)'
            }}
          >
            <DashboardIcon />
          </Icon>
        </IconButton>
      </div>
    )

    return media
  }

  merge = () => {
    const {
      article
    } = this.state

    article.selected.sort((a, b) => a.row <= b.row && a.column <= b.column ? -1 : 1)

    let valid = false
    let singleRow = false
    let singleColumn = false

    let startRow = -1
    let startColumn = -1
    let endRow = -1
    let endColumn = -1

    let colSpanCount = -1
    let rowSpanCount = -1

    let skipStartRow = -1
    let skipRow = -1

    if (article.selected.length > 1) {
      for (let i = 0; i < article.selected.length; i++) {
        // console.log('[' + article.selected[i].row + ', ' + article.selected[i].column + ']')

        if (i === 0) {
          // console.log('First Selected')

          startRow = article.selected[i].row
          startColumn = article.selected[i].column
        } else if (i === article.selected.length - 1) {
          // console.log('Last Selected')

          endRow = article.selected[i].row
          endColumn = article.selected[i].column
        } else {
          // console.log('Middle Selected')
        }
      }
    }    

    let row = startRow
    let column = startColumn

    console.log('End Row: ' + endRow)
    console.log('End Column: ' + endColumn)

    console.log('Start Row: ' + startRow)
    console.log('Start Column: ' + startColumn)
    console.log('End Row: ' + endRow)
    console.log('End Column: ' + endColumn)

    colSpanCount = endColumn - startColumn + 1
    rowSpanCount = endRow - startRow + 1

    console.log('Column Span: ' + (endColumn - startColumn + 1))
    console.log('Row Span: ' + (endRow - startRow + 1))

    console.log('Skip Start Row: ' + (endColumn - startColumn))
    console.log('Skip Row: ' + (endColumn - startColumn + 1))

    skipStartRow = endColumn - startColumn
    skipRow = endColumn - startColumn + 1

    if (startRow === endRow) {
      singleRow = true
    }

    if (startColumn === endColumn) {
      singleColumn = true
    }

    actions.articleActions.addSpan({
      row,
      column,
      colSpanCount,
      rowSpanCount
    })

    for (let i = 0; i < rowSpanCount; i++) {
      if (i === 0) {
        actions.articleActions.addSkip({
          row,
          skip: skipStartRow
        })
      } else {
        actions.articleActions.addSkip({
          row: row + i,
          skip: skipRow
        })
      }
    }

    this.unselectAll()
  }

  text = () => {
    const { article } = this.state

    let included = false

    if (article.selected.length > 0) {
      for (let i = 0; i < article.selected.length; i++) {
        if (article.text.length < 1) {
          actions.articleActions.addMedia({
            row: article.selected[i].row,
            column: article.selected[i].column,
            type: 0,
            id: 'p' + article.info.currentPage + 'r' + article.selected[i].row + 'c' + article.selected[i].column + 't'
          })
        } else if (article.text.length > 0) {
          for (let j = 0; j < article.text.length; j++) {
            if (article.selected[i].row == article.text[j].row && article.selected[i].column == article.text[j].column) {
              included = true
            }
          }

          if (!included) {
            actions.articleActions.addMedia({
              row: article.selected[i].row,
              column: article.selected[i].column,
              type: 0,
              id: 'p' + article.info.currentPage + 'r' + article.selected[i].row + 'c' + article.selected[i].column + 't'
            })
          } else {
            actions.articleActions.removeMedia({
              row: article.selected[i].row,
              column: article.selected[i].column
            })
          }
        }
      }
    }

    // this.unselectAll()
  }

  image = () => {
    const { article } = this.state

    let included = false

    if (article.selected.length > 0) {
      for (let i = 0; i < article.selected.length; i++) {
        if (article.image.length < 1) {
          actions.articleActions.addMedia({
            row: article.selected[i].row,
            column: article.selected[i].column,
            type: 1,
            id: 'p' + article.info.currentPage + 'r' + article.selected[i].row + 'c' + article.selected[i].column + 'i'
          })
        } else if (article.image.length > 0) {
          for (let j = 0; j < article.image.length; j++) {
            if (article.selected[i].row == article.image[j].row && article.selected[i].column == article.image[j].column) {
              included = true
            }
          }

          if (!included) {
            actions.articleActions.addMedia({
              row: article.selected[i].row,
              column: article.selected[i].column,
              type: 1,
              id: 'p' + article.info.currentPage + 'r' + article.selected[i].row + 'c' + article.selected[i].column + 'i'
            })
          } else {
            actions.articleActions.removeMedia({
              row: article.selected[i].row,
              column: article.selected[i].column
            })
          }
        }
      }
    }

    // this.unselectAll()
  }

  video = () => {
    const { article } = this.state

    let included = false

    if (article.selected.length > 0) {
      for (let i = 0; i < article.selected.length; i++) {
        if (article.video.length < 1) {
          actions.articleActions.addMedia({
            row: article.selected[i].row,
            column: article.selected[i].column,
            type: 2,
            id: 'p' + article.info.currentPage + 'r' + article.selected[i].row + 'c' + article.selected[i].column + 'v'
          })
        } else if (article.video.length > 0) {
          for (let j = 0; j < article.video.length; j++) {
            if (article.selected[i].row == article.video[j].row && article.selected[i].column == article.video[j].column) {
              included = true
            }
          }

          if (!included) {
            actions.articleActions.addMedia({
              row: article.selected[i].row,
              column: article.selected[i].column,
              type: 2,
              id: 'p' + article.info.currentPage + 'r' + article.selected[i].row + 'c' + article.selected[i].column + 'v'
            })
          } else {
            actions.articleActions.removeMedia({
              row: article.selected[i].row,
              column: article.selected[i].column
            })
          }
        }
      }
    }

    // this.unselectAll()
  }

	unselectAll = () => {
    const { article } = this.state

		actions.articleActions.unselectSelectedCell({
      index: article.info.currentPage
    })
	}

	renderArticle = () => {
		const { article } = this.state

		let articleElement = []

		articleElement.push(
			<IconButton
				edge={ 'end' }
				className={ 'MenuButton' }
				color="inherit" 
				aria-label="menu"
				onClick={() => {
						actions.articleActions.changeContextMenu({
						subMenuOpen: !article.contextMenu.subMenuOpen ? true : article.contextMenu.subMenuOpen && !article.contextMenu.article ? true : false,
						resize: false,
						media: false,
						split: false,
						border: false,
						edit: false,
						article: !article.contextMenu.article,
						align: false
					})
				}}
			>
				<Icon>
					<DescriptionIcon />
				</Icon>
			</IconButton>
		)

		return articleElement
	}

	dragEnter = (event) => {
		console.log('DRAG ENTER')

		console.log(event)

		event.preventDefault()
		event.stopPropagation()
	}

	dragLeave = (event) => {
		console.log('DRAG LEAVE')

		console.log(event)

		event.preventDefault()
		event.stopPropagation()
	}

	dragOver = (event) => {
		console.log('DRAG OVER')

		console.log(event)

		event.preventDefault()
		event.stopPropagation()
	}

	drop = (event) => {
		console.log('DROP')

		console.log(event)
		console.log(event.target)
		console.log(event.target.id)
		console.log(event.dataTransfer.files)

		let targetId = event.target.id

		event.preventDefault()
		event.stopPropagation()

		let reader = new FileReader()
		reader.readAsDataURL(event.dataTransfer.files[0])
		reader.onloadend = function() {
			let img = document.createElement('img')
			img.src = reader.result as string

			console.log(img)

			img.style.width = '100%'
			img.style.height = '100%'
			document.getElementById(targetId).appendChild(img)
		}
	}

	render() {		
		const { article } = this.state

		// console.log(table)

		return (
			<div
            	className='EditorContextMenu'
            	style={{
            		position: 'fixed',
					left: article && article.contextMenu && !article.contextMenu.fixed ? article.contextMenu.posX : 0,
					top: article && article.contextMenu && !article.contextMenu.fixed ? article.contextMenu.posY : article.contextMenu.orientation === 0 ? 0 : 'calc(100% - 50px)',
					border: article.contextMenu.open ? '1px solid black' : 'none',
					backgroundColor: 'rgba(255, 255, 255, 255)',
					zIndex: 1
            	}}
            >

              {
                article.contextMenu.open ? this.renderContextMenu() : null
              }

              {
                article.contextMenu.open && article.contextMenu.subMenuOpen ? this.renderContextSubMenu() : null
              }

            </div>
		);
	}
}

export default EditorContextMenu;